<nav class="h-7rem sm:h-3rem">
  <p-megaMenu
    styleClass="background-color: red;"
    styleClass="shadow-2 fixed w-full top-0 surface-card border-none"
    [style]="{ 'z-index': '1000' }"
    [model]="items"
  ></p-megaMenu>
</nav>

<p-sidebar class="animation-sidebar" [(visible)]="sidebarVisible">
  <div class="svg_img">
    <img
      src="../../../../assets/img/sidebar/ComisionParitaria.svg"
      style="width: 140px"
      alt=""
    />
  </div>
  <h2 class="mb-0">SICOL</h2>
  <div>
    <div class="buttons-container">
      <hr />
      <ng-container *ngIf="isSuperAdmin; else regularUser">
        <div
          class="button-container"
          (click)="goToSelect('/main/home')"
          [ngClass]="{
            'bg-bluegray-700 border-round': currentRoute == '/main/home'
          }"
        >
          <div class="nav_option" routerLinkActive="selected-button">
            <div class="box" routerLinkActive="box-selected"></div>
            <a routerLinkActive="active">
              <img src="../../../../assets/img/sidebar/home.png" alt="" />
              Inicio
            </a>
          </div>
        </div>

        <div
          class="button-container"
          (click)="goToSelect('/main/users')"
          [ngClass]="{
            'bg-bluegray-700 border-round': currentRoute == '/main/users'
          }"
        >
          <div class="nav_option" routerLinkActive="selected-button">
            <div class="box" routerLinkActive="box-selected"></div>
            <a routerLinkActive="active">
              <img
                class="spAdmin"
                src="../../../../assets/img/sidebar/user.png"
                alt=""
              />
              Usuarios
            </a>
          </div>
        </div>

        <div
          class="button-container"
          (click)="goToSelect('/main/companies')"
          [ngClass]="{
            'bg-bluegray-700 border-round': currentRoute == '/main/companies'
          }"
        >
          <div class="nav_option" routerLinkActive="selected-button">
            <div class="box" routerLinkActive="box-selected"></div>
            <a routerLinkActive="active">
              <img
                class="spAdmin"
                src="../../../../assets/img/sidebar/company.png"
                alt=""
              />
              Empresas
            </a>
          </div>
        </div>
      </ng-container>
      <ng-template #regularUser>
        <div
          class="button-container"
          (click)="goToSelect('/main/home')"
          [ngClass]="{
            'bg-bluegray-700 border-round': currentRoute == '/main/home'
          }"
        >
          <div class="nav_option" routerLinkActive="selected-button">
            <div class="box" routerLinkActive="box-selected"></div>
            <a routerLinkActive="active">
              <img src="../../../../assets/img/sidebar/home.png" alt="" />
              Inicio
            </a>
          </div>
        </div>

        <div
          class="button-container"
          (click)="goToSelect('/main/claims')"
          [ngClass]="{
            'bg-bluegray-700 border-round': currentRoute == '/main/claims'
          }"
        >
          <div class="nav_option" routerLinkActive="selected-button">
            <div class="box" routerLinkActive="box-selected"></div>
            <a routerLinkActive="active" class="claim-icon">
              <img src="../../../../assets/img/sidebar/reclamos.png" alt="" />
              {{ claimButtonText }}
            </a>
          </div>
        </div>

        <div
          *ngIf="commisionRol"
          class="button-container"
          (click)="goToSelect('/main/audiences')"
          [ngClass]="{
            'bg-bluegray-700 border-round': currentRoute == '/main/audiences'
          }"
        >
          <div class="nav_option" routerLinkActive="selected-button">
            <div class="box" routerLinkActive="box-selected"></div>
            <a routerLinkActive="active" class="claim-icon">
              <img src="../../../../assets/img/sidebar/audience.png" alt="" />
              Audiencias
            </a>
          </div>
        </div>
        <div
          *ngIf="userRol == 'Administrador'"
          class="button-container"
          (click)="goToSelect('/main/claims-archived')"
        >
          <div class="nav_option" routerLinkActive="selected-button">
            <div class="box" routerLinkActive="box-selected"></div>
            <a routerLinkActive="active" class="claim-icon">
              <i class="pi pi-bookmark" style="font-size: 1.2rem"></i>

              Archivados
            </a>
          </div>
        </div>
        <div
          class="button-container"
          (click)="goToSelect('/main/configuration')"
          [ngClass]="{
            'bg-bluegray-700 border-round':
              currentRoute == '/main/configuration'
          }"
        >
          <div class="nav_option" routerLinkActive="selected-button">
            <div class="box" routerLinkActive="box-selected"></div>
            <a routerLinkActive="active">
              <img
                src="../../../../assets/img/sidebar/settings.png"
                alt=""
              />Configuración
            </a>
          </div>
        </div>
      </ng-template>
      <hr />
    </div>

    <div class="button-container" (click)="showLogoutConfirm()">
      <div class="nav_option">
        <div class="box"></div>
        <a>
          <img src="../../../../assets/img/sidebar/logout.png" alt="" />Cerrar
          sesión
        </a>
      </div>
    </div>
  </div>
  <div class="text-center pt-6">
    <a target="_blank" href="https://encodelabs.com.ar/home">
      <img
        class="w-5 ml-7"
        src="../../../../assets/img/login/new-logo-encode-white.png"
        alt="Logo encodelabs"
      />
    </a>

    <div class="col-12 pt-0">
      <p class="version">v.3.0</p>
    </div>
  </div>
</p-sidebar>
<p-confirmDialog
  [style]="{ width: '40rem' }"
  [breakpoints]="{ '960px': '75vw', '640px': '90vw', '320px': '100vw' }"
>
</p-confirmDialog>
